<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img
          width="60%"
          :src="require('@/assets/images/logo/playgol.svg')"
          alt=""
        />
        <!-- <vuexy-logo /> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Bienvenido! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            ¡ PLAYGOL ! Digitalizando tus torneos
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="Usuario" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="usuarioejemplo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                  <b-link :to="{ name: 'forgot' }">
                    <small>Olvido contraseña?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group v-show="false">
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                v-if="!showLoading"
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Ingresar
              </b-button>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
              <!-- <b-button type="submit" variant="primary" block @click="getRooms">
                roomsSocket
              </b-button> -->
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'page-auth-register-v2'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              BY INGENIANDO SOLUTIONS
            </div>
          </div>

          <!-- social buttons -->
          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              target="_blank"
              href="https://www.facebook.com/ingeniandosolutions"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              target="_blank"
              href="https://www.play-gol.com"
            >
              <feather-icon icon="GlobeIcon" />
            </b-button>
            <!-- <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button> -->
            <!-- <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button> -->
          </div>
          <span style="float:right; font-size:12px">versión {{ VERSION }}</span>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
// import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import socket from '@/services/socket'
import tenant from '../config/tenant'

import {
  // setUser,
  URL,
  STORAGE_NAME,
  ROLES,
  VERSION,
  ID_CLIENTE,
  // USER,
  // xxxx
} from '../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    // VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      // userEmail: 'j@j.com',
      // password: 'j',
      userEmail: '',
      password: '',
      sideImg: tenant.fondoLogin,
      // validation rulesimport store from '@/store/index'
      required,
      email,
      showLoading: false,
      VERSION,
    }
  },
  mounted() {
    localStorage.setItem(STORAGE_NAME, null)
    // console.log('aqui')
    // socket.on('connect', () => {
    //   console.log('✅ Conectado al servidor')
    // })
    // socket.on('partidos_activos_respuesta', data => {
    //   console.log('✅ partidos activos')
    //   console.log(data)
    // })
    // socket.on('estadoEnVivoRespuesta', data => {
    //   console.log('✅ eventos recibidos')
    //   console.log(data)
    // })
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      // if (store.state.appConfig.layout.skin === 'dark') {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   // this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
      //   this.sideImg = require(tenant.fondoLogin)
      //   return this.sideImg
      // }
      return this.sideImg
    },
  },
  methods: {
    getRooms() {
      socket.emit('listar_partidos_activos')
      socket.emit('registrar_user_partido', {
        partidoId: '74_660',
      })
    },
    async doLogin(user) {
      // console.log(JSON.stringify(user))
      const url = `${URL}ApiLogin/isLogin` // VARIABLE CREADA EN GLOBAL
      const resp = await axios
        .post(url, JSON.stringify(user))
        .then(response => response.data)
        .catch(() => null)
      // console.log(resp);
      return resp
    },
    async signIn(user, pass) {
      this.showLoading = true
      const objUser = {
        usuario: user,
        contrasena: pass,
        id_cliente: ID_CLIENTE,
      }
      const login = await this.doLogin(objUser)
      // console.log(login)
      // localStorage.setItem(STORAGE_NAME, JSON.stringify(login.user))
      // console.log('login', localStorage.getItem('user_pgol'))
      if (login.flag === 'si') {
        if (
          login.user.rol === ROLES.CLUB ||
          login.user.rol === ROLES.SUPER ||
          login.user.rol === ROLES.CALIFICACION ||
          login.user.rol === ROLES.ADMIN
        ) {
          this.iniciaSession(login.user, '/inscriptions')
        } else if (login.user.rol === 'tecnica') {
          this.iniciaSession(login.user, '/tecnica')
        } else if (login.user.rol === 'sanciones') {
          this.iniciaSession(login.user, '/sanciones')
        } else if (login.user.rol === 'superadmin') {
          this.iniciaSession(login.user, '/configuration')
        } else if (login.user.rol === 'tesoreria') {
          this.iniciaSession(login.user, '/tesoreria')
        }
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Usuario o contraseña incorrectos',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-right',
            // eslint-disable-next-line
          },
        )
      }
      this.showLoading = false
    },
    iniciaSession(user, ruta) {
      const data = {
        ...user,
        app_version: VERSION,
      }
      // this.$session.start()
      // this.$session.set('user_pgol', user)
      localStorage.setItem(STORAGE_NAME, JSON.stringify(data))
      // store.commit(
      //   'someVariables/UPDATE_TORNEO_SELECCIONADO',
      //   // eslint-disable-next-line
      //   USER().torneos[0]
      // )
      // setUser(JSON.stringify(user))
      this.$router.push(ruta)
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.signIn(this.userEmail, this.password)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
